export const scheduleDaysMaster: Array<{ value: string; label: string }> = [
    { value: '0', label: '日曜' },
    { value: '1', label: '月曜' },
    { value: '2', label: '火曜' },
    { value: '3', label: '水曜' },
    { value: '4', label: '木曜' },
    { value: '5', label: '金曜' },
    { value: '6', label: '土曜' },
];
